import { lazy } from "react";
import { RouteObject, Navigate } from "react-router-dom";

const FieldList = lazy(() => import("../pages/FieldList"));
const CropIdentify = lazy(() => import("../pages/cropIdentify"));
const CropGrowth = lazy(() => import("../pages/cropGrowth"));
const DrawingShape = lazy(() => import("../pages/drawShape"));
const FarmPanel = lazy(() => import("../pages/farmPanel"));
const Filters = lazy(() => import("../pages/Filters"));
const AreaOfInterest = lazy(() => import("../pages/AreaOfInterest"));
const SidePanel = lazy(() => import("../pages/sidePanel"));

const Landing = lazy(() => import("../Container/Landing"));
const Container = lazy(() => import("../Container/Container"));

export const appRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/terramate" />,
  },
  {
    path: "/terramate",
    element: <Landing />,
  },
  {
    path: "/app",
    element: <Container />,
    children: [
      { path: "listAll", element: <FieldList /> },
      { path: "crop-identify", element: <CropIdentify /> },
      { path: "crop-growth", element: <CropGrowth /> },
      { path: "shape", element: <DrawingShape map={null} /> },
      { path: "filter/:name", element: <Filters /> },
      { path: "myFarm/draw", element: <FarmPanel /> },
      { path: "aoi/draw", element: <SidePanel /> },
      { path: "tracking", element: <AreaOfInterest map={null} /> },
    ],
  },
];
